export const baseUrl = "https://api.onebyone.ng/api/v1";
    // export const baseUrl = "https://test-api.onebyone.ng/api/v1";

export const getToken = () => localStorage.getItem("authToken");

export const paystackPublicKey = "pk_test_d3a868516d0046522c079db689cbfa759714399e";

